export enum DataLayerEventName {
  FilterOn = 'filterOn',
  FilterOff = 'filterOff',
  SideBarFilter = 'sideBarFilter',
  FiltersOpen = 'filter_open',
  FilterInteraction = 'filter_interaction',
  FiltersApplied = 'filter_applyed',
  SearchCount = 'searchCount',
  Search = 'search',
  SearchClick = 'searchClick',
  PriceCalendarClick = 'clickPriceCalendar',
  EmptyCalendarClick = 'clickEmptyCalendar',
  TabId = 'tab_id',
  Step = 'step',
  Start = 'start',
  MaxStep = 'maxStep',
  CacheResults = 'cacheResults',
  PreSearchPagePath = 'preSearchPagePath',
  Sid = 'sid',
  CityFrom = 'cityFrom',
  CountryTo = 'countryTo',
  HotelClass = 'hotelClass',
  TouristGroup = 'touristGroup',
  Night = 'night',
  Date = 'date',
  InContent = 'inContent',
  SelectContent = 'selectContent',
}

export enum DataLayerFilterInteraction {
  Click = 'click',
  CheckboxOn = 'checkbox_on',
}

export enum SearchGoal {
  FlexibleDaysClick = 'calendar_flexible_click',
  EmptySearch = 'empty_search',
}

export interface DataLayerSearchClick {
  hotelIndex: number;
  hotelId: number;
  price: number;
  oilTax: number | null;
}

export interface DataLayerTouristRoom {
  adults: number;
  kids: number;
  infants: number;
  ages: number[];
}

export interface DataLayerTouristGroup extends DataLayerTouristRoom {
  touristsByRooms: DataLayerTouristRoom[];
}

export interface DataLayerSearchCriteria {
  cityFrom: number;
  countryIds: readonly number[];
  hotelStars: readonly number[];
  touristGroup: DataLayerTouristGroup;
  nights: { from: number; to: number };
  dates: { from: string; to: string; daysFlexible: number };
}

export type DataLayerRangeItem<V = number | string> = {
  value: V;
  type: string;
};

export type DataLayerListItem = {
  value: number;
};

export type DataLayerVariableEvent<N extends DataLayerEventName, V> = { event: N } & { [K in N]: V };

export type GooutBannerContent = {
  prop: [{ type: string; value: string }];
};

export type BannerShowDataLayerEvent = {
  event: DataLayerEventName.InContent;
  inContent: GooutBannerContent;
};

export type BannerClickDataLayerEvent = {
  event: DataLayerEventName.SelectContent;
  inContent: GooutBannerContent;
};

export type FilterToggleDataLayerEvent = {
  event: DataLayerEventName.FilterOn | DataLayerEventName.FilterOff;
  value: string;
};

export type SideBarFilterDataLayerEvent = {
  event: DataLayerEventName.SideBarFilter;
  beach: string;
};

export type FiltersOpenDataLayerEvent = {
  event: DataLayerEventName.FiltersOpen;
  is_wl: number;
};

export type FilterInteractionDataLayerEvent = {
  filter_type: string;
  filter_interaction: DataLayerFilterInteraction;
  filter_page: string;
  is_wl: number;
  event: DataLayerEventName.FilterInteraction;
};

export type FiltersAppliedDataLayerEvent = {
  filter_travelata_exclusive_only_regular_flights: 0 | 1;
  filter_page: string;
  is_wl: number;
  event: DataLayerEventName.FiltersApplied;
};

export type SearchCountDataLayerEvent = {
  event: DataLayerEventName.SearchCount;
  searchCount: number;
};

export type SearchDataLayerEvent = {
  event: DataLayerEventName.Search;
  search: { prop: [{ type: string; value: string }] };
};

export type SearchClickDataLayerEvent = {
  event: DataLayerEventName.SearchClick;
  searchClick: DataLayerRangeItem[];
};

export type CalendarDayClickDataLayerEvent =
  | { event: DataLayerEventName.PriceCalendarClick; clickPriceCalendar: '' }
  | { event: DataLayerEventName.EmptyCalendarClick; clickEmptyCalendar: '' };
